export default function(now, latest) {
  if (!now) {
    return false;
  }
  if (!latest) {
    return true;
  }
  const nowArr = now.split('.');
  const latestArr = latest.split('.');
  for (let i = 0; i < Math.max(nowArr.length, latestArr.length); i++) {
    if (Number(latestArr[i]) > Number(nowArr[i])) {
      return true;
    }
    if (Number(latestArr[i]) < Number(nowArr[i])) {
      return false;
    }
  }
  return false;
}
